import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CreateAssignedZoneParkersRequest, ParkingTypeService, ParkingZoneDto, ParkingZoneService, ParkingSpaceDto } from '../../../../../api/gen';

export interface AssignedZoneTypeResult {
  success: boolean;
  data?: any;
}

@Component({
  selector: 'app-add-assigned-zone-type',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSnackBarModule
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './add-assigned-zone-type.component.html',
  styleUrl: './add-assigned-zone-type.component.scss'
})
export class AddAssignedZoneTypeComponent implements OnInit {
  private fb = inject(FormBuilder);
  private parkingTypeService = inject(ParkingTypeService);
  private parkingZoneService = inject(ParkingZoneService);
  private snackBar = inject(MatSnackBar);
  @Input({ required: true }) parkingOperatorId: string | undefined;

  @Input() parkingSpace!: ParkingSpaceDto;
  @Output() submitted = new EventEmitter<AssignedZoneTypeResult>();

  form!: FormGroup;
  isLoading = signal(false);
  isLoadingZones = signal(false);
  availableZones = signal<ParkingZoneDto[]>([]);

  ngOnInit(): void {
    this.initForm();
    this.loadAvailableZones();
  }

  private initForm(): void {
    this.form = this.fb.group({
      availableForParkingZones: [[]],
      availableFrom: [null],
      availableTo: [null]
    });
  }

  private loadAvailableZones(): void {
    this.isLoadingZones.set(true);
    this.availableZones.set(this.parkingSpace.parkingZones || []);
    this.isLoadingZones.set(false);
  }

  submit(): void {
    this.isLoading.set(true);

    const formValue = this.form.value;
    const request: CreateAssignedZoneParkersRequest = {
      availableFrom: formValue.availableFrom ? new Date(formValue.availableFrom).toISOString() : null,
      availableTo: formValue.availableTo ? new Date(formValue.availableTo).toISOString() : null,
      availableForParkingSpaces: this.parkingSpace?.id ? [this.parkingSpace.id] : null,
      availableForParkingZones: formValue.availableForParkingZones?.length > 0 ? formValue.availableForParkingZones : null,
      organizationId: null
    };

    this.parkingTypeService.parkingTypesAssignedZoneParkersPost(this.parkingOperatorId, request).subscribe({
      next: (result) => {
        this.snackBar.open('Assigned zone parkers created successfully', 'Close', { duration: 3000 });
        this.isLoading.set(false);
        this.submitted.emit({ success: true, data: result });
      },
      error: (error) => {
        console.error('Error creating assigned zone parkers:', error);
        this.snackBar.open('Failed to create assigned zone parkers', 'Close', { duration: 3000 });
        this.isLoading.set(false);
        this.submitted.emit({ success: false });
      }
    });
  }
}
